module.exports = __webpack_public_path__ + "media/images/application2/AppBookingsTalk__bottom__buttons__a--audio-38a17b051f85111bd198110fddcc069c.svg";